import React from "react";
import { FormattedMessage, injectIntl, Link } from "gatsby-plugin-intl";
import { Container, Segment, Grid, List, Header } from "semantic-ui-react";
import HardLink from "./HardLink";

const Footer = ({ intl }) => (
  <Segment inverted vertical style={{ padding: "5em 0em" }}>
    <Container>
      <Grid divided inverted stackable>
        <Grid.Row>
          <Grid.Column width={3}>
            <Header
              inverted
              as="h4"
              content={intl.formatMessage({ id: "nav_picpick" })}
            />
            <List link inverted>
              <List.Item as={Link} name="index" to="/">
                <FormattedMessage id="nav_home" />
              </List.Item>
              <List.Item as={Link} name="features" to="/features">
                <FormattedMessage id="nav_features" />
              </List.Item>
              <List.Item as={Link} name="download" to="/download">
                <FormattedMessage id="nav_download" />
              </List.Item>
              {intl.locale !== "ko" && (
                <List.Item as={HardLink} name="buy" to="/buy">
                  <FormattedMessage id="nav_buy" />
                </List.Item>
              )}
            </List>
          </Grid.Column>
          <Grid.Column width={6}>
            <Header
              inverted
              as="h4"
              content={intl.formatMessage({ id: "about_us" })}
            />
            <List link inverted>
              <List.Item as={Link} name="contact" to="/contact">
                <FormattedMessage id="nav_contact" />
              </List.Item>
              {intl.locale !== "ko" && (
                <List.Item as={Link} name="partners" to="/partners">
                  <FormattedMessage id="nav_partners" />
                </List.Item>
              )}
              <List.Item as={Link} name="eula" to="/eula">
                <FormattedMessage id="section_eula" />
                {" | "}
                <FormattedMessage id="section_privacypolicy" />
              </List.Item>
              <List.Item as={Link} name="eula" to="/buy/refund">
                <FormattedMessage id="section_refund" />
              </List.Item>
            </List>
          </Grid.Column>
          <Grid.Column width={7} textAlign="right">
            <p style={{ marginTop: 20 }}>
              <FormattedMessage
                id="text_copyright"
                values={{
                  ngwin: (
                    <b>
                      <span className="color-ng">NG</span>
                      <span className="color-win">WIN</span>
                    </b>
                  ),
                  copy: <span>&copy;</span>,
                }}
              />
            </p>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Container>
  </Segment>
);

export default injectIntl(Footer);
